module.exports = __webpack_public_path__ + "images/emoji/clock830.ef1e4c5ba604506ad6b8.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/clock830.png
// module id = 9D/q
// module chunks = 2